import { Link, Outlet } from '@tanstack/react-router';
import { Building2, LayoutDashboard, Settings, ShieldCheck } from 'lucide-react';

import { BottomNav, type BottomNavItem } from './BottomNav';

import { cn } from '@/lib/utils';

const nav: BottomNavItem[] = [
  { to: '/', label: 'Tableau de bord', shortLabel: 'Accueil', icon: LayoutDashboard, exact: true },
  { to: '/tenants', label: 'Tenants', icon: Building2 },
  { to: '/admins', label: 'Admins', icon: ShieldCheck },
  { to: '/settings', label: 'Paramètres', icon: Settings },
];

/** Pages connectées : navigation latérale dès md, BottomNav en dessous ; en-tête et UserMenu fournis par RootLayout. */
export const AuthedLayout = () => (
  <div className="flex flex-1 flex-col md:flex-row">
    <nav aria-label="Navigation principale" className="hidden w-56 shrink-0 border-r bg-white md:block">
      <ul className="flex flex-col gap-1 p-3">
        {nav.map(({ to, label, icon: Icon, exact }) => (
          <li key={to}>
            <Link
              to={to}
              activeOptions={{ exact: Boolean(exact) }}
              // Link pose data-status="active" sur le lien courant
              className={cn(
                'flex items-center gap-3 whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-muted-foreground transition-colors',
                'hover:bg-muted hover:text-foreground',
                'data-[status=active]:bg-brand-violet/10 data-[status=active]:text-brand-violet',
              )}
            >
              <Icon className="h-4 w-4 shrink-0" aria-hidden />
              {label}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
    {/* Sous md : le bas du contenu reste au-dessus de la BottomNav (4 rem + safe area) */}
    <div className="flex min-w-0 flex-1 flex-col bg-muted/30 pb-[calc(4rem+env(safe-area-inset-bottom))] md:pb-0">
      <Outlet />
    </div>
    <BottomNav items={nav} />
  </div>
);
